import React from 'react'
import PropTypes from 'prop-types'
import i18n from 'simple-react-i18n'
import { Card, CardContent, Grid, Stack, Typography } from '@mui/material'
import { CardTitle } from 'components/card/NewCard'

const ParameterCard = ({
    title,
    children,
    isGlobal = false,
}) => (
    <Card variant='newCard'>
        <CardTitle title={<Typography variant='cardTitle'>{title}</Typography>} />
        <CardContent>
            <Stack spacing={1.25} sx={{ '& .MuiAutocomplete-root': { margin: 0 }, '& .MuiTextField-root': { paddingTop: '0 !important' } }}>
                {!isGlobal && (
                    <Grid container justifyContent='flex-end' columnSpacing={1} sx={{ paddingBottom: 1.25 }}>
                        <Grid size={3.25}><Typography variant='formTitle'>{i18n.globalToTheApplication}</Typography></Grid>
                        <Grid size={3.25}><Typography variant='formTitle'>{i18n.byModule}</Typography></Grid>
                        <Grid size={0.5} />
                    </Grid>
                )}
                {children}
            </Stack>
        </CardContent>
    </Card>
)

ParameterCard.propTypes = {
    title: PropTypes.string,
    children: PropTypes.element,
    isGlobal: PropTypes.bool,
}

export default ParameterCard
